import React, { ReactNode } from 'react';
import Link from 'carbon-react/lib/components/link';
import Icon from 'carbon-react/lib/components/icon';
import Box from 'carbon-react/lib/components/box';

import { FormattedMessage } from '@futrli/localisation';

interface ListingPageHelpLinkProps {
  url: string;
  title?: ReactNode;
}

export const ListingPageHelpLink = ({ url, title }: ListingPageHelpLinkProps) => (
  <Box display="flex" alignItems="center">
    <Icon type="question" color="#007e45" mr="8px" />
    <Link href={url} target="_blank" rel="noopener noreferrer">
      {title || <FormattedMessage id="predict.help_opens_in_new_tab" defaultMessage="Help (opens in new tab)" />}
    </Link>
  </Box>
);
